import { UseQueryOptions } from '@tanstack/react-query';

import { gqlClient } from '../../contentful/Client';

import {
  GetAllRadarQuery,
  useGetAllRadarQuery,
} from '../../generated/graphql';


export const useRadarList = (
  options?: UseQueryOptions<GetAllRadarQuery>,
) => {
  return useGetAllRadarQuery(
    gqlClient(false),
    {
      preview: false,
    },
    options,
  );
};
